import { render, staticRenderFns } from "./BtnFlag.vue?vue&type=template&id=91bda34e&"
import script from "./BtnFlag.vue?vue&type=script&lang=js&"
export * from "./BtnFlag.vue?vue&type=script&lang=js&"
import style0 from "./BtnFlag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports